<template>
    <Navbar />

    <main class="w-full my-4 px-3 tablet:w-9/12 tablet:mx-auto">
        <router-view />
    </main>

    <Footer category="full" />
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

export default {
    name: 'UserLayout',
    data() {
        return {
        }
    },
    components: {
        Navbar,
        Footer,
    }
}
</script>
